import React, { Component, ReactNode } from "react";
import "./index.scss";
import DefaultLayout from "layouts/Default";

export interface AuthLayoutProps {
  id?: string;
  sidebarChildren?: ReactNode;
  children: ReactNode;
  className?: string;
}

export default class AuthLayout extends Component<AuthLayoutProps> {
  render() {
    const className = this.props.className
      ? `${this.props.className} auth-layout`
      : "auth-layout";
    return <DefaultLayout id={className}>{this.props.children}</DefaultLayout>;
  }
}
